(function () {
  'use strict';
  if (window.textualShippingCountry) return;
  var pending;

  function publish(country) {
    document.documentElement.setAttribute('data-shipping-country', country || 'unknown');
    document.dispatchEvent(new CustomEvent('textual:shipping-country-changed'));
  }

  function detect() {
    if (pending) return pending;
    // Never infer location from USD, the default market, or a previous page.
    // Unknown/failed lookups leave shipping promotions hidden.
    publish('');
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 4000);
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    pending = fetch(route + 'browsing_context_suggestions.json?country[enabled]=true', {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Country lookup failed');
      return response.json();
    }).then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;
      var code = country && country.handle;
      publish(typeof code === 'string' && /^[A-Z]{2}$/.test(code) ? code : '');
    }).catch(function () {
      publish('');
    }).finally(function () {
      clearTimeout(timeout);
      pending = null;
    });
    return pending;
  }

  window.textualShippingCountry = detect;
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) detect();
  });
  detect();
}());
